(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabUpdateScriptsDeleteController', TabUpdateScriptsDeleteController);

    TabUpdateScriptsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabUpdateScripts'];

    function TabUpdateScriptsDeleteController($uibModalInstance, entity, TabUpdateScripts) {
        var vm = this;
        vm.tabUpdateScripts = entity;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            TabUpdateScripts.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
